var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 -2 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39515 12.6826H0V7.54629H5.39515V12.6826ZM14 12.6675H6.22603V10.8698H14V12.6675ZM14 9.33796H6.22502V7.54025H13.999L14 9.33796ZM5.47774 6.05172H0.0745269V1.01611H5.47774V6.05172ZM13.9849 6.05172H6.21797V4.25603H13.9849V6.05172ZM14 2.79671H6.22603V1H14V2.79671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewList);
export default __webpack_public_path__ + "static/media/view_list.c3bbbc8e.svg";
export { ForwardRef as ReactComponent };